import React from "react";

import moment from "moment";
import { useTranslation } from "react-i18next";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/src/components/ui/alert-dialog";

import type { JSX } from "react";

import type { FastSchedulingConflictSlot } from "@/src/api/MediaAPI.types";

interface FastSchedulingConflictDialogProps {
  slotList: FastSchedulingConflictSlot[];
  onClose: () => void;
}

// parseZone keeps the channel offset sent by the back instead of converting to local time.
function formatSlotTime(time: string): string {
  return moment.parseZone(time).format("L HH:mm");
}

export default function FastSchedulingConflictDialog({
  slotList,
  onClose,
}: FastSchedulingConflictDialogProps): JSX.Element {
  const { t } = useTranslation("editor-content");

  return (
    <AlertDialog open onOpenChange={(isOpen) => !isOpen && onClose()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t("fastConflictTitle")}</AlertDialogTitle>
          <AlertDialogDescription>
            {t("fastConflictDescription")}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <ul className="flex max-h-80 flex-col gap-2 overflow-y-auto text-sm">
          {slotList.map((slot) => (
            <li
              key={`${slot.fast_channel_name}-${slot.start_time}`}
              className="border-border flex flex-col rounded-md border px-3 py-2"
            >
              <span className="font-medium">{slot.fast_channel_name}</span>
              <span className="text-muted-foreground">
                {`${formatSlotTime(slot.start_time)} → ${formatSlotTime(slot.end_time)} (${slot.timezone})`}
              </span>
            </li>
          ))}
        </ul>
        <AlertDialogFooter>
          <AlertDialogAction onClick={onClose}>
            {t("fastConflictClose")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
